import React, { useState, useContext, useEffect } from 'react';
import ThemeContext from '../context/theme.Context';
import { Redirect } from 'react-router-dom';
import LoadingContext from '../context/loading.context';
import UserDetailsContext from '../context/userDetails.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';

import icon from '../images/icon.svg';

const Register = (props) => {
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { token } = useContext(UserDetailsContext);

    // Form elements:
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [registerError, setRegisterError] = useState('');
    const [validated, setValidated] = useState(false);

    const [redirectLocation, setRedirectLocation] = useState(token ? '/' : '');

    const confirmPasswordRef = React.createRef();

    const apiHostName = Constants.API_URL;

    useEffect(() => {
        // Check if we've got a query parameter 'email'. If so, prefill that in:
        var index = props.location.search.indexOf('email=');
        if (index < 0) {
            // No email specified, do nothing...
            return;
        }
        var argEmail = props.location.search.substring(index + 6);
        if (argEmail.indexOf('&') >= 0) {
            argEmail = argEmail.substring(0, argEmail.indexOf('&'));
        }
        setEmail(argEmail);

    }, []);

    // Check that both passwords are identical:
    function updatePassword(value) {
        setPassword(prevstate => {
            confirmPasswordRef.current.setCustomValidity(value === confirmPassword ? '' : "Passwords don't match.");
            return value;
        });
    }
    function updateConfirmPassword(value) {
        setConfirmPassword(prevstate => {
            confirmPasswordRef.current.setCustomValidity(password === value ? '' : "Passwords don't match.");
            return value;
        });
    }


    // If form is valid, submit it to the server:
    function handleSubmit(event) {

        event.preventDefault();

        // Check form validation
        const form = event.currentTarget;
        setButtonDisabled(true);
        setRegisterError('');
        setValidated(true);

        confirmPasswordRef.current.setCustomValidity(password === confirmPassword ? '' : "Passwords don't match.");

        if (form.checkValidity() === false) {
            // Invalid form, so stop processing
            event.stopPropagation();
            setButtonDisabled(false);
            return;
        }
        showLoading();

        // Form is valid, so submit to the server:
        const userData = { UserName: userName, Password: password, Email: email };
        fetch(apiHostName + '/v1/users/register', {
            mode: "cors",
            method: 'POST',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(userData)
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.json();
                }
                return new Promise(function (resolve, reject) { resolve("OK"); });
            })
            .then((result) => {
                // Result contains a text message that the action was successful - ignore this...
                if (result !== "OK") {
                    setRegisterError('Registration failed: ' + result.message);
                    hideLoading();
                    setButtonDisabled(false);
                }
                else {
                    // Ok, user is registered - redirect to login form...
                    hideLoading();
                    setRedirectLocation('/login');
                }
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot register user...");
                console.error(error);
                setRegisterError('Network error');
                hideLoading();
                setButtonDisabled(false);
            });



    }

    return (
        redirectLocation ? <Redirect to={{ pathname: redirectLocation, state: { message: 'Registration successful, please login.' } }} />
            :
            <ThemeContext.Consumer>
                {(themeContext) => (
                    <React.Fragment>
                        <Row style={{ justifyContent: 'center' }}>
                            <div className="register-card">
                                <div style={{ justifyContent: 'center', display: 'flex' }}>
                                    <div className="brand_logo_container">
                                        <img src={icon} className="brand_logo" alt="Logo" />
                                    </div>
                                </div>
                                <div className="form-container">
                                    <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                                        <Form.Group className="form-title">
                                            <div>Create account</div>
                                        </Form.Group>
                                        <Form.Group controlId="formUsername">
                                            <span className="input-group-text"><FontAwesomeIcon icon="user" /></span>
                                            <Form.Control type="text" name="Username" placeholder="Username" pattern="[A-Za-z0-9._\-@]{3,}" value={userName} onChange={(e) => { setUserName(e.target.value); }} required />
                                            <div className="control-feedback">
                                                <Form.Control.Feedback type="invalid">
                                                    Please fill in your username.
                                                </Form.Control.Feedback>
                                            </div>

                                        </Form.Group>

                                        <Form.Group controlId="formPassword">
                                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                                            <Form.Control type="password" name="Password" placeholder="Password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d).{6,}$" value={password} onChange={(e) => { updatePassword(e.target.value); }} required />
                                            <div className="control-feedback">
                                                <Form.Control.Feedback type="invalid">
                                                    Please fill in your password.
                                                </Form.Control.Feedback>
                                            </div>
                                        </Form.Group>

                                        <Form.Group controlId="formConfirmPassword">
                                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                                            <Form.Control type="password" name="ConfirmPassword" placeholder="Confirm password" value={confirmPassword} ref={confirmPasswordRef} onChange={(e) => { updateConfirmPassword(e.target.value); }} />
                                            <div className="control-feedback">
                                                <Form.Control.Feedback type="invalid">
                                                    Please confirm your password.
                                                </Form.Control.Feedback>
                                            </div>
                                        </Form.Group>

                                        <Form.Group controlId="formEmail">
                                            <span className="input-group-text"><FontAwesomeIcon icon="envelope" /></span>
                                            <Form.Control type="email" name="email" placeholder="E-mail address" value={email} onChange={(e) => { setEmail(e.target.value); }} />
                                        </Form.Group>

                                        <div>E-mail address is only used for service notifications - no advertisement.</div>

                                        <Form.Group>
                                            <Button className="login-button" disabled={buttonDisabled} type="submit">Register <Spinner /></Button>
                                        </Form.Group>
                                        <Form.Label className="invalid-login">{registerError}</Form.Label>
                                    </Form>
                                </div>
                            </div>
                        </Row>
                    </React.Fragment>
                )}
            </ThemeContext.Consumer>
    );
};

export default Register;


// WEBPACK FOOTER //
// ./src/components/Register.js